"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _useStaticInfo = require("./browser/hooks/useStaticInfo");
var _Suspense = _interopRequireDefault(require("./Suspense"));

/* eslint-disable import/no-dynamic-require */
// Override the suspense module to be our own
// This is expected to break when using preact
// In order to make it work with preact 10, use `patch-package` to remove those 2 lines
// Reference: https://github.com/react-static/react-static/pull/1500
React.Suspense = _Suspense["default"];
React["default"].Suspense = _Suspense["default"];
var App = require("".concat(process.env.REACT_STATIC_ENTRY_PATH))["default"];
var _default = function _default(staticInfo) {
  return function (props) {
    return /*#__PURE__*/React.createElement(_useStaticInfo.staticInfoContext.Provider, {
      value: staticInfo
    }, /*#__PURE__*/React.createElement(App, props));
  };
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9ib290c3RyYXBBcHAuanMiXSwibmFtZXMiOlsiUmVhY3QiLCJTdXNwZW5zZSIsIkFwcCIsInJlcXVpcmUiLCJwcm9jZXNzIiwiZW52IiwiUkVBQ1RfU1RBVElDX0VOVFJZX1BBVEgiLCJzdGF0aWNJbmZvIiwicHJvcHMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBSEE7QUFLQTtBQUNBO0FBQ0E7QUFDQTtBQUNBQSxLQUFLLENBQUNDLFFBQU4sR0FBaUJBLG9CQUFqQjtBQUNBRCxLQUFLLFdBQUwsQ0FBY0MsUUFBZCxHQUF5QkEsb0JBQXpCOztBQUVBLElBQU1DLEdBQUcsR0FBR0MsT0FBTyxXQUFJQyxPQUFPLENBQUNDLEdBQVIsQ0FBWUMsdUJBQWhCLEVBQVAsV0FBWjs7ZUFFZSxrQkFBQUMsVUFBVTtBQUFBLFNBQUksVUFBQUMsS0FBSztBQUFBLHdCQUNoQyxvQkFBQyxnQ0FBRCxDQUFtQixRQUFuQjtBQUE0QixNQUFBLEtBQUssRUFBRUQ7QUFBbkMsb0JBQ0Usb0JBQUMsR0FBRCxFQUFTQyxLQUFULENBREYsQ0FEZ0M7QUFBQSxHQUFUO0FBQUEsQyIsInNvdXJjZXNDb250ZW50IjpbIi8qIGVzbGludC1kaXNhYmxlIGltcG9ydC9uby1keW5hbWljLXJlcXVpcmUgKi9cbmltcG9ydCAqIGFzIFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHsgc3RhdGljSW5mb0NvbnRleHQgfSBmcm9tICcuL2Jyb3dzZXIvaG9va3MvdXNlU3RhdGljSW5mbydcbmltcG9ydCBTdXNwZW5zZSBmcm9tICcuL1N1c3BlbnNlJ1xuXG4vLyBPdmVycmlkZSB0aGUgc3VzcGVuc2UgbW9kdWxlIHRvIGJlIG91ciBvd25cbi8vIFRoaXMgaXMgZXhwZWN0ZWQgdG8gYnJlYWsgd2hlbiB1c2luZyBwcmVhY3Rcbi8vIEluIG9yZGVyIHRvIG1ha2UgaXQgd29yayB3aXRoIHByZWFjdCAxMCwgdXNlIGBwYXRjaC1wYWNrYWdlYCB0byByZW1vdmUgdGhvc2UgMiBsaW5lc1xuLy8gUmVmZXJlbmNlOiBodHRwczovL2dpdGh1Yi5jb20vcmVhY3Qtc3RhdGljL3JlYWN0LXN0YXRpYy9wdWxsLzE1MDBcblJlYWN0LlN1c3BlbnNlID0gU3VzcGVuc2VcblJlYWN0LmRlZmF1bHQuU3VzcGVuc2UgPSBTdXNwZW5zZVxuXG5jb25zdCBBcHAgPSByZXF1aXJlKGAke3Byb2Nlc3MuZW52LlJFQUNUX1NUQVRJQ19FTlRSWV9QQVRIfWApLmRlZmF1bHRcblxuZXhwb3J0IGRlZmF1bHQgc3RhdGljSW5mbyA9PiBwcm9wcyA9PiAoXG4gIDxzdGF0aWNJbmZvQ29udGV4dC5Qcm92aWRlciB2YWx1ZT17c3RhdGljSW5mb30+XG4gICAgPEFwcCB7Li4ucHJvcHN9IC8+XG4gIDwvc3RhdGljSW5mb0NvbnRleHQuUHJvdmlkZXI+XG4pXG4iXX0=
void function register() {
  /* react-hot-loader/webpack */var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;
  if (!reactHotLoader) {
    return;
  } /* eslint-disable camelcase, no-undef */
  var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : exports; /* eslint-enable camelcase, no-undef */
  if (!webpackExports) {
    return;
  }
  if (typeof webpackExports === 'function') {
    reactHotLoader.register(webpackExports, 'module.exports', "/home/runner/work/shoutout_site/shoutout_site/node_modules/react-static/lib/bootstrapApp.js");
    return;
  } /* eslint-disable no-restricted-syntax */
  for (var key in webpackExports) {
    /* eslint-enable no-restricted-syntax */if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) {
      continue;
    }
    var namedExport = void 0;
    try {
      namedExport = webpackExports[key];
    } catch (err) {
      continue;
    }
    reactHotLoader.register(namedExport, key, "/home/runner/work/shoutout_site/shoutout_site/node_modules/react-static/lib/bootstrapApp.js");
  }
}();